import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {MenusModule} from '@progress/kendo-angular-menu';
import {RefModelStoreService} from '@q9elements/ui-kit/common';
import {AttachNodeService} from '../editor-interface/services/attach-node.service';

import {RmeNodeLinkageService, TabConfigService} from '@q9elements/ui-kit/refmodels';
import {SharedModule} from '../shared/shared.module';
import {ContextMenuActionsService} from './services/context-menu-actions.service';
import {ContextMenuItemsService} from './services/context-menu-items.service';
import {ContextMenuViewService} from './services/context-menu-view.service';

@NgModule({
  imports: [CommonModule, TranslateModule, MenusModule, SharedModule],
  providers: [
    ContextMenuActionsService,
    ContextMenuViewService,
    ContextMenuItemsService,
    AttachNodeService,
    RmeNodeLinkageService,
    TabConfigService,
    RefModelStoreService
  ]
})
export class GridContextMenuModule {}
